import React from "react";
import styles from "./Checkbox.module.scss";

const Checkbox = ({ id, label, isChecked, setIsChecked, ...props }) => {
  return (
    <div className={styles.checkboxWrapper}>
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type="checkbox"
        checked={isChecked}
        onChange={setIsChecked}
        {...props}
        className={isChecked ? styles.checked : ""}
      />
    </div>
  );
};
export default Checkbox;
